import {Spin} from "antd";
import React from "react";
import {CircularProgress} from "@mui/material";
import styled from "styled-components";

const loadingIndicator = <CircularProgress
    style={{
        fontSize: 50,
        color: '#005696',
    }}
/>

const StyledSpin = styled(Spin)`
    .ant-spin-description {
        padding-top: 16px;
        color: var(--white);
        text-shadow: none;
        text-align: center;
    }
`;

const Spinner = ({description}) => (
    <StyledSpin spinning={true}
          indicator={loadingIndicator}
          className={"centered"}
          style={{fontSize: '20px', width: '80%'}}
          description={description}
    />
)

export default Spinner;
